














export default {
    name: 'ChooseGroup',
    methods: {
        init() {
            Miele.ModuleLoader.createModuleInstance("elements/form/choose-group", this.$el);
        },
    },
    mounted() {
        this.init();
    },
};
